import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statementprofile',
  templateUrl: './statementprofile.component.html',
  styleUrls: ['./statementprofile.component.css']
})
export class StatementprofileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
